import { Routes } from '@angular/router'
import { FeatureEditProjectComponent } from './feature-edit-project.component'

export const FEATURE_EDIT_PROJECT_ROUTES: Routes = [
   {
      path: '',
      component: FeatureEditProjectComponent
   },
   {
      path: ':tabindex',
      component: FeatureEditProjectComponent
   }
]
